<template>
  <div class="container">
    <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
      <div class="mx-auto col-xl-4 col-lg-5 col-md-7">
        <div class="card z-index-0 mt-10">
          <div class="card-body">
            <soft-badge
              color="warning"
              variant="gradient"
              size="sm"
              @click="$emit('form-submitted')"
              class="cursor-pointer float-right"
            >
              {{ $t("global.close") }}
            </soft-badge>
            <p class="my-3 text-bold">{{ $t("courses.createNewCourse") }}</p>
            <form @submit.prevent="submitForm">
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0"
                  >({{ $t("global.requiredField") }})</span
                >
                <InputForm
                  v-model="formData.title"
                  :placeholder="$t('courses.title')"
                  type="text"
                  :isRequired="true"
                />
              </div>
              <div class="text-center">
                <soft-button
                  color="dark"
                  full-width
                  variant="gradient"
                  class="my-4 mb-2"
                >
                  {{ $t("global.create") }}
                </soft-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import InputForm from "@/components/InputForm.vue";
import SoftButton from "@/components/SoftButton.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import swal from "sweetalert2";

export default {
  name: "FormCreateCourse",
  components: {
    InputForm,
    SoftButton,
    SoftBadge,
  },
  data() {
    return {
      formData: {
        title: "",
      },
      courses: [],
    };
  },
  created() {
    this.getCourses();
  },
  methods: {
    async submitForm(event) {
      event.preventDefault();
      try {
        await axios.post("course", {
          title: this.formData.title,
        });
        this.resetForm();
        swal.fire({
          icon: "success",
          title: this.$t("courses.createdSuccessfully"),
          showConfirmButton: false,
          timer: 2000,
        });
        this.$emit("form-submitted", true);
      } catch (error) {
        if (error.response && error.response.status === 422) {
          const errors = error.response.data.errors;
          let errorMessages = "";

          if (typeof errors === "function") {
            for (const key in errors) {
              if (errors.prototype.hasOwnProperty.call(errors, key)) {
                errorMessages += `- ${errors[key].join(", ")}\n`;
                swal.fire({
                  title: this.$t("global.error"),
                  html: errorMessages.replace(/\n/g, "<br>"),
                  icon: "error",
                  position: "top-end",
                });
              }
            }
          } else {
            for (const key in errors) {
              errorMessages += `- ${errors[key].join(", ")}\n`;
              swal.fire({
                title: this.$t("global.error"),
                html: errorMessages.replace(/\n/g, "<br>"),
                icon: "error",
                position: "top-end",
              });
            }
          }
        }
      }
    },
    async getCourses() {
      const response = await axios.get("courses/all");
      this.courses = response.data.courses;
    },
    resetForm() {
      this.formData.title = "";
      return;
    },
  },
};
</script>

<style scoped>
.float-right {
  float: right;
}
</style>
